/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type FolderMenu_viewer = {
    readonly portfolios: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly serviceId: string | null;
                readonly " $fragmentRefs": FragmentRefs<"FolderMenuOption_portfolio">;
            } | null;
        } | null> | null;
    } | null;
    readonly " $refType": "FolderMenu_viewer";
};
export type FolderMenu_viewer$data = FolderMenu_viewer;
export type FolderMenu_viewer$key = {
    readonly " $data"?: FolderMenu_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"FolderMenu_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "firmMembers"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "FolderMenu_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 100
        },
        {
          "kind": "Literal",
          "name": "portfolioTypes",
          "value": [
            "FOLDER"
          ]
        },
        {
          "kind": "Literal",
          "name": "sortBy",
          "value": "MODIFIED"
        },
        {
          "kind": "Variable",
          "name": "userIds",
          "variableName": "firmMembers"
        }
      ],
      "concreteType": "PortfoliosConnection",
      "kind": "LinkedField",
      "name": "portfolios",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PortfoliosEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PortfolioV2",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "serviceId",
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "FolderMenuOption_portfolio"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '3941f784cfdb844726bcafb6ee67c847';
export default node;
